<template>
  <div class="add-real-report-container" v-if="visible">
    <div class="content">
      <el-form :model="ruleForm" ref="ruleForm" label-width="180px">
        <template>
          <div class="title">签名信息</div>
          <el-form-item label="签名:" required class="mgb_16">
            <el-input
              v-model.trim="ruleForm.signature"
              placeholder="请填入"
              class="w484"
            ></el-input>
            <div class="tip">
              注意：此处报备的签名需与当前生效中的签名一致，否则无法使用
            </div>
          </el-form-item>
        </template>
        <template>
          <div class="title mgt_16">企业信息</div>
          <div class="head-box w602 mgb_16 mgt_16">
            <div class="head-content">
              <span class="icon_i">i</span>
              <span class="block">
                请提供签名所属企业/店铺的营业执照上的信息</span
              >
            </div>
          </div>
          <el-form-item label="公司名:" required>
            <el-input
              v-model="ruleForm.companyName"
              placeholder="请填入"
              class="w484"
            ></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码:" required>
            <el-input
              v-model="ruleForm.creditCode"
              placeholder="请填入"
              class="w484"
            ></el-input>
          </el-form-item>
          <el-form-item label="主体公司法人姓名:" required>
            <el-input
              v-model="ruleForm.legalPersonName"
              placeholder="请填入"
              class="w484"
            ></el-input>
          </el-form-item>
          <el-form-item label="法人身份证号:" required>
            <el-input
              v-model="ruleForm.legalPersonIdCard"
              placeholder="请填入"
              class="w484"
            ></el-input>
          </el-form-item>
        </template>
        <template>
          <div class="title mgt_16">经办人信息</div>
          <div class="head-box w602 mgb_16 mgt_16">
            <div class="head-content">
              <span class="icon_i">i</span>
              <span class="block"> 同一个经办人不允许报备多家企业</span>
            </div>
          </div>
          <el-form-item label="经办人:" required>
            <el-input
              v-model="ruleForm.handlerName"
              placeholder="请填入"
              class="w484"
            ></el-input>
          </el-form-item>
          <el-form-item label="经办人身份证号:" required>
            <el-input
              v-model="ruleForm.handlerIdCard"
              placeholder="请填入"
              class="w484"
            ></el-input>
          </el-form-item>
          <el-form-item label="经办人手机号:" required>
            <el-input
              @focus="handleFocus"
              v-model="showMobile"
              placeholder="请填入"
              class="w484"
            ></el-input>
          </el-form-item>
        </template>
        <template>
          <div class="title mgt_16 mgb_16">短信示例</div>
          <el-form-item label="短信内容示例:" class="mgb_16">
            <el-input
              type="textarea"
              class="textarea"
              style="width: 484px"
              resize="none"
              v-model="ruleForm.smsContent"
              :autosize="{ minRows: 6, maxRows: 6 }"
            ></el-input>
          </el-form-item>
        </template>
      </el-form>
    </div>
    <div class="footer-bottom">
      <el-button
        type="primary"
        style="margin-right: 8px"
        @click="onSubmit"
        :loading="submitLoading1"
        >提交</el-button
      >
      <el-button
        v-if="
          controlType !== 'edit' ||
          (controlType == 'edit' && ![4, 5].includes(rowData.reportStatus))
        "
        type="primary"
        style="margin-right: 8px"
        @click="onSave"
        :loading="submitLoading2"
        >保存</el-button
      >
      <el-button @click="onBack">取消</el-button>
    </div>
  </div>
</template>

<script>
import { modifyData } from "../../../utils/util2";
import { saveReportRecord } from "@/api/backstage/messageBill";
import { getSellerInfo } from "@/api/sellerController"; //获取当前客户信息
const useFormData = () => {
  return {
    signature: "",
    companyName: "",
    creditCode: "",
    legalPersonName: "",
    legalPersonIdCard: "",
    handlerName: "",
    handlerIdCard: "",
    smsContent: "",
  };
};
/**
 * 新增，编辑，实时报备
 */
export default {
  name: "AddRealReport",
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    /**add 添加 edit 编辑 copy 复制 */
    controlType: {
      type: String,
      default: "add",
    },
    //数据详情
    rowData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      ruleForm: useFormData(),
      visible: false,
      submitLoading1: false,
      submitLoading2: false,
      shopInfo: {}, // 店铺信息
      showMobile: "", //显示的手机号
    };
  },
  watch: {
    value(val) {
      this.visible = val;
      if (val) {
        console.log("rowData>>", this.rowData, this.controlType);
        let formData = useFormData();
        modifyData(formData, this.rowData);
        console.log("shopInfo>>", this.shopInfo);
        if (this.shopInfo.isSimulation) {
          // 模拟登录
          this.showMobile = this.rowData.chaosHandlerMobile;
        } else {
          this.showMobile = this.rowData.handlerMobile;
        }
        this.ruleForm = formData;
      }
    },
  },
  mounted() {
    this.getSoftwareInfo();
  },
  methods: {
    handleFocus(event) {
      const inputElement = event.target;
      inputElement.addEventListener("copy", this.handleCopy);
      inputElement.addEventListener("cut", this.handleCut);
    },
    handleCopy(event) {
      event.preventDefault(); // 阻止复制操作
    },
    handleCut(event) {
      event.preventDefault(); // 阻止剪切操作
    },
    /** *
     * 获取店铺信息
     * */
    getSoftwareInfo() {
      getSellerInfo({}).then((res) => {
        this.shopInfo = res.data;
      });
    },

    onBack() {
      this.ruleForm = useFormData();
      this.$emit("input", false);
    },

    //提交
    async onSubmit() {
      if (!this.ruleForm.signature) {
        this.$message.warning("请输入签名");
        return;
      }
      if (!this.ruleForm.companyName) {
        this.$message.warning("请输入公司名");
        return;
      }
      if (!this.ruleForm.creditCode) {
        this.$message.warning("请输入统一社会信用代码");
        return;
      }
      if (!this.ruleForm.legalPersonName) {
        this.$message.warning("请输入主体公司法人姓名");
        return;
      }
      if (!this.ruleForm.legalPersonIdCard) {
        this.$message.warning("请输入法人身份证号");
        return;
      }
      if (!this.ruleForm.handlerName) {
        this.$message.warning("请输入经办人");
        return;
      }
      if (!this.ruleForm.handlerIdCard) {
        this.$message.warning("请输入经办人身份证号");
        return;
      }
      if (!this.showMobile) {
        this.$message.warning("请输入经办人手机号");
        return;
      }
      // 判断是否是模拟登录
      if (this.shopInfo.isSimulation) {
        // 判断当前输入框的脱敏手机号是否和后台返回的脱敏手机号一致
        if (this.showMobile != this.rowData.chaosHandlerMobile) {
          this.ruleForm.handlerMobile = this.showMobile;
          if (!/^1[3456789]\d{9}$/.test(this.ruleForm.handlerMobile)) {
            this.$message.warning("请输入正确的手机号码");
            return;
          }
        } else {
          // 如果一致，将后台返回的手机号赋值给ruleForm.handlerMobile
          this.ruleForm.handlerMobile = this.rowData.handlerMobile;
        }
      } else {
        // 如果不是模拟登录，将当前输入框的手机号赋值给ruleForm.handlerMobile
        this.ruleForm.handlerMobile = this.showMobile;
        // 校验手机号
        if (!/^1[3456789]\d{9}$/.test(this.ruleForm.handlerMobile)) {
          this.$message.warning("请输入正确的手机号码");
          return;
        }
      }
      this.submitLoading1 = true;
      let param = {
        ...this.ruleForm,
        isSubmit: 1, //是否提交 0保存草稿 1提交
      };
      if (this.controlType == "edit") param.id = this.rowData.id;
      console.log("param>>", param);
      // return
      try {
        const res = await saveReportRecord(param);
        this.submitLoading1 = false;
        if (res.code == 1) {
          this.$message.success("提交成功");
          this.onBack();
          this.$emit("update");
        } else {
          this.$message.error(res.message);
        }
      } catch (err) {
        this.submitLoading1 = false;
      }
    },

    //保存为草稿
    async onSave() {
      if (!this.ruleForm.signature) {
        this.$message.warning("请输入签名");
        return;
      }
      // 判断当前经办人手机号是否为空
      if (this.showMobile) {
        // 如果不为空则走之前的判断逻辑
        // 判断是否是模拟登录
        if (this.shopInfo.isSimulation) {
          // 判断当前输入框的脱敏手机号是否和后台返回的脱敏手机号一致
          if (this.showMobile != this.rowData.chaosHandlerMobile) {
            this.ruleForm.handlerMobile = this.showMobile;
          } else {
            // 如果一致，将后台返回的手机号赋值给ruleForm.handlerMobile
            this.ruleForm.handlerMobile = this.rowData.handlerMobile;
          }
        } else {
          // 如果不是模拟登录，将当前输入框的手机号赋值给ruleForm.handlerMobile
          this.ruleForm.handlerMobile = this.showMobile;
        }
      }
      this.submitLoading2 = true;
      let param = {
        ...this.ruleForm,
        isSubmit: 0, //是否提交 0保存草稿 1提交
      };
      if (this.controlType == "edit") param.id = this.rowData.id;
      console.log("param>>", param);
      try {
        const res = await saveReportRecord(param);
        this.submitLoading2 = false;
        if (res.code == 1) {
          this.$message.success("保存成功");
          this.onBack();
          this.$emit("update");
        } else {
          this.$message.error(res.message);
        }
      } catch (err) {
        this.submitLoading2 = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.w484 {
  width: 484px;
}

.w602 {
  width: 662px;
}

.mgt_16 {
  margin-top: 16px;
}

.mgb_16 {
  margin-bottom: 16px;
}

.textarea {
  .el-textarea__inner {
    min-height: 200px !important;
  }

  /deep/.el-textarea__inner::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  /deep/.el-textarea__inner::-webkit-scrollbar-thumb {
    border-radius: 3px;
    -moz-border-radius: 3px;
    -webkit-border-radius: 3px;
    background-color: #c3c3c3;
  }

  /deep/.el-textarea__inner::-webkit-scrollbar-track {
    background-color: transparent;
  }
}

.add-real-report-container {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 90vh;
  background: #fff;
  z-index: 2;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-radius: 8px;

  .content {
    flex: 1;
    padding: 20px;
    box-sizing: border-box;

    .tip {
      color: rgb(254, 77, 69);
      font-size: 14px;
      margin-top: 8px;
    }

    .title {
      width: 100%;
      font-weight: bold;
      color: #1f1f1f;
      position: relative;
      font-size: 16px;
      padding-left: 10px;
      &::before {
        position: absolute;
        left: 0px;
        top: 1px;
        content: "";
        display: block;
        width: 2px;
        height: 14px;
        background: rgb(254, 77, 69);
      }
    }
  }

  .footer-bottom {
    width: 100%;
    height: 59px;
    border-top: 1px solid #f2f2f2;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.head-box {
  //  padding: 24px;
  background: #fffaee;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 10px;
  overflow: hidden;
  font-size: 14px;
  color: #333333;
  margin-top: 20px;
  .head-icon {
    float: left;
    margin-right: 8px;
  }
  .head-content {
    float: left;
    width: 64%;
    line-height: 20px;
    position: relative;
    .icon_i {
      display: inline-block;
      position: absolute;
      width: 14px;
      height: 14px;
      border-radius: 14px;
      background-color: #ffb95e;
      color: #fff;
      font-size: 10px;
      font-weight: bold;
      text-align: center;
      line-height: 14px;
      font-weight: bold;
      top: 3px;
      left: 10px;
    }
    .block {
      width: 800px;
      display: block;
      margin-left: 29px;
    }
  }
}
</style>
